import React from 'react'

import ChatroomItem from './ChatroomItem'
import Chatroom from '../../../containers/ChatRoomContainer'
import Loading from '../../../components/Loading/Loading'

// Import Scss
import './ChatroomList.scss'

// Import images
import iconChatGrey from '../../../images/icon-chat-grey.png'

class ChatroomList extends React.Component {

  componentDidMount() {
    this.props.fetchChatrooms()
  }

  onChatroomItemClick = (chatroomId) => {
    this.props.setShowingChatroomId(chatroomId)
  }

  onBackToListClick = () => {
    this.props.setShowingChatroomId(null)
  }

  render() {
    const {chatrooms, showingChatroomId} = this.props

    const chatroomIds = Object.keys(chatrooms)
    if (!chatroomIds.length) return <Loading />

    if(chatroomIds.length === 0) {
      return (
        <div className="no-result">
          <img src={iconChatGrey} alt='icon' />
          <h3>サポートはまだありません。お待ちください。</h3>
        </div>
      )
    } else if(chatroomIds.length === 1) {
      return(
        <div className="one-room">
          <Chatroom
            mode="normal_chatroom"
            chatroomId={chatroomIds}
          />
        </div>
      )
    }

    if (showingChatroomId) {
      return(
        <div className="chatroom-list">
          <div
            className="chatroom-breadcrumb"
            onClick={this.onBackToListClick}
          >
            一覧へ戻る
          </div>
          <Chatroom
            mode="normal_chatroom"
            chatroomId={showingChatroomId}
          />
        </div>
      )
    }

    let chatroomList = chatroomIds.map(chatroomId => (
      <ChatroomItem
        key={chatroomId}
        chatroom={chatrooms[chatroomId]}
        onChatroomItemClick={this.onChatroomItemClick}
      />
    ))

    return(
      <div>
        <ul className="chatroom-list">
          {
            chatroomList
          }
        </ul>
      </div>
    )
  }
}

export default ChatroomList



// WEBPACK FOOTER //
// ./src/routes/support/components/ChatroomList.js